<template>
    <div class="services">
        <div class="title">
            <router-link :to="{ name: 'ServicesCreate' }" v-if="role == 'admin'">
                <IconComponent class="icon" icon="add" />
            </router-link>
            <TableComponent :columns="filterColumns" :elements="services"
                :destination="(service) => ({ name: 'ServicesInfo', params: { id: service.id } })" />
        </div>
    </div>
</template>

<script>
import IconComponent from '@/components/Icons.vue';
import TableComponent from '@/components/Table.vue';

export default {
    name: 'ServicesList',
    props: {},
    components: {
        IconComponent,
        TableComponent,
    },
    data() {
        return {
            columns: [
                { text: 'Nome', attribute: 'name' },
                { icon: 'trash', method: this.delete, role: 'admin' }
            ],
        }
    },

    methods: {
        delete(service) {
            if (this.role == 'admin') {
                this.$store.dispatch('services/delete', service.id)
            }
        },
    },

    computed: {
        services() {
            const services = this.$store.state.services.all
            return services.sort((a, b) => {
                if (a.name == null || b.name == null) return
                return a.name.localeCompare(b.name)
            })
        },

        role() {
            return this.$store.state.users.role;
        },

        filterColumns() {
            return this.columns.filter((column) => !column.role || column.role == this.role)
        }
    },

    mounted() {
        this.$store.dispatch('services/getAll')
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

.services {
    .title {
        margin: 1rem 2rem;

        &-h1 {
            margin-top: 0;
        }

        .icon {
            width: 20px;
            height: 20px;
            fill: var(--text-color);
        }
    }
}
</style>
